module.exports = __webpack_public_path__ + "static/media/bg-top.2b291558.png";